/**
 * Signals that a print could not be delivered because the dashboard on the
 * printer's PC is not open (so nothing is connected to receive the job).
 * A modal listens for this and tells the user exactly what to do.
 */
export interface PrintAgentOfflineDetail {
  /** Host (PC name / IP) that owns the printer. */
  host: string;
  /** Windows share name of the printer, when known (precise agent match). */
  shareName?: string;
  /** Human name of the printer, when known. */
  printerName?: string;
}

export const PRINT_AGENT_OFFLINE_EVENT = 'firstaid:print-agent-offline';

export function notifyPrintAgentOffline(detail: PrintAgentOfflineDetail): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent<PrintAgentOfflineDetail>(PRINT_AGENT_OFFLINE_EVENT, { detail }));
}
